import {Component , Vue} from "vue-property-decorator";
import EventBus from "../../../../utils/event-bus";
import {EVENT_BUS} from "../../../../common/constants";

@Component({
	name: "UserMenuComponent",
	template: require("./template.html")
})

export default class UserMenuComponent extends Vue {
	public lblSetting: any = null;
	mounted() {
		EventBus.$on(EVENT_BUS.COMMON.LOADED_TRANSALTED, () => {
			this.$forceUpdate()
        });
	}
}